import { css } from '@eti/styles';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const exitRowClass = css`
  height: 1.375rem;
  margin-bottom: 0;
  margin-top: 0;
  width: 2rem;
`;
const styles = exitRow => css`
  background: transparent;
  ${exitRow ? exitRowClass : rowItemSize};
`;
const EmptySpace = _ref => {
  let {
    isExitRow
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles(isExitRow),
    "data-testid": "emptySpace"
  });
};
export default EmptySpace;
//# sourceMappingURL=EmptySpace.js.map